import InputTypesEnum from '../../../../../Enums/InputTypesEnum';
import ThirdPartyJobPaymentsService from '../../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import EvaluatorPaymentActionParamsItem from '../../../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem';

export default class VoidWindowDescription {
  static titleForCreate = 'Void';
  static titleForEdit = 'Void';
  static finishButtonLabel = 'Void';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => ThirdPartyJobPaymentsService.Void(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
